export const suppressedSubBrandsExactMatch = [
  'AX',
  'FORGE',
  'INSIDER',
  'NEXUS',
  'NITRUS',
  'SHOCKWAVE',
  'TORCH',
  'WRECKER'
];
